const cm_CONSTANT_entity_tables = [
  {
    category: "",
    items: [
      { label: "MAINTENANCE_AGENCY", value: "MaintenanceAgency" },
      { label: "FRAMEWORK", value: "Framework" },
    ],
  },
  {
    category: "Core",
    items: [
      { label: "DOMAIN", value: "Domain" },
      { label: "FACET_COLLECTION", value: "FacetCollection" },
      { label: "FACET_ENUMERATION", value: "FacetEnumeration" },
      { label: "MEMBER", value: "Member" },
      { label: "MEMBER_HIERARCHY", value: "MemberHierarchy" },
      { label: "MEMBER_HIERARCHY_NODE", value: "MemberHierarchyNode" },
      { label: "SUBDOMAIN", value: "Subdomain" },
      { label: "SUBDOMAIN_ENUMERATION", value: "SubdomainEnumeration" },
      { label: "VARIABLE", value: "Variable" },
      { label: "VARIABLE_SET", value: "VariableSet" },
      { label: "VARIABLE_SET_ENUMERATION", value: "VariableSetEnumeration" },
    ],
  },
  {
    category: "Data Definition",
    items: [
      { label: "COMBINATION", value: "Combination" },
      { label: "COMBINATION_ITEM", value: "CombinationItem" },
      { label: "MEMBER_LINK", value: "MemberLink" },
      { label: "CUBE", value: "Cube" },
      { label: "CUBE_LINK", value: "CubeLink" },
      { label: "CUBE_GROUP", value: "CubeGroup" },
      { label: "CUBE_GROUP_ENUMERATION", value: "CubeGroupEnumeration" },
      { label: "CUBE_HIERARCHY", value: "CubeHierarchy" },
      { label: "CUBE_HIERARCHY_NODE", value: "CubeHierarchyNode" },
      { label: "CUBE_RELATIONSHIP", value: "CubeRelationship" },
      { label: "CUBE_STRUCTURE", value: "CubeStructure" },
      { label: "CUBE_STRUCTURE_ITEM_LINK", value: "CubeStructureItemLink" },
      { label: "CUBE_STRUCTURE_ITEM", value: "CubeStructureItem" },
      { label: "CUBE_TO_COMBINATION", value: "CubeToCombination" },
      { label: "FRAMEWORK_HIERARCHY", value: "FrameworkHierarchy" },
      { label: "FRAMEWORK_SUBDOMAIN", value: "FrameworkSubdomain" },
      { label: "FRAMEWORK_VARIABLE_SET", value: "FrameworkVariableSet" },
    ],
  },
  {
    category: "Mapping",
    items: [
      { label: "CUBE_MAPPING", value: "CubeMapping" },
      { label: "COMBINATION_MAPPING", value: "CombinationMapping" },
      { label: "MAPPING_DEFINITION", value: "MappingDefinition" },
      { label: "MAPPING_TO_CUBE", value: "MappingToCube" },
      { label: "MEMBER_MAPPING", value: "MemberMapping" },
      { label: "MEMBER_MAPPING_ITEM", value: "MemberMappingItem" },
      { label: "VARIABLE_MAPPING", value: "VariableMapping" },
      { label: "VARIABLE_MAPPING_ITEM", value: "VariableMappingItem" },
      { label: "VARIABLE_SET_MAPPING", value: "VariableSetMapping" },
      { label: "CUBE_STRUCTURE_MAPPING", value: "CubeStructureMapping" },
      {
        label: "CUBE_STRUCTURE_MAPPING_ITEM",
        value: "CubeStructureMappingItem",
      },
    ],
  },
  {
    category: "Rendering",
    items: [
      { label: "AXIS", value: "Axis" },
      { label: "AXIS_ORDINATE", value: "AxisOrdinate" },
      { label: "CELL_POSITION", value: "CellPosition" },
      { label: "ORDINATE_ITEM", value: "OrdinateItem" },
      { label: "TABLE", value: "Table" },
      { label: "TABLE_CELL", value: "TableCell" },
      { label: "CUBE_TO_TABLE", value: "CubeToTable" },
    ],
  },
  {
    category: "Transformation",
    items: [
      { label: "TRANSFORMATION", value: "Transformation" },
      { label: "TRANSFORMATION_NODE", value: "TransformationNode" },
      { label: "TRANSFORMATION_SCHEME", value: "TransformationScheme" },
      {
        label: "SEMANTIC_TRANSFORMATION_RULE",
        value: "SemanticTransformationRule",
      },
      {
        label: "TRANSFORMATION_TO_CUBE",
        value: "TransformationToCube",
      },
      {
        label: "TRANSFORMATION_TO_VARIABLE",
        value: "TransformationToVariable",
      },
      {
        label: "LOGICAL_TRANSFORMATION_RULE",
        value: "LogicalTransformationRule",
      },
    ],
  },
  {
    category: "Legal Reference",
    items: [
      { label: "LEGAL_REFERENCE", value: "LegalReference" },
      { label: "LEGAL_TEXT", value: "LegalText" },
      { label: "CLASSIFICATION", value: "Classification" },
      { label: "CLASSIFICATION_ASSIGNMENT", value: "ClassificationAssignment" },
    ],
  },
];

const labelForClassifications = [
  { label: "name", value: "Name" },
  { label: "code", value: "Code" },
  { label: "description", value: "Description" },
];
const labelForLegalReference = [
  { label: "legalCode", value: "Legal Code" },
  { label: "businessDescription", value: "Business Description" },
  { label: "hyperlink", value: "Hyperlink" },
];

const EntityTypesThatCanBeOrphan = [
  "Combination",
  "CombinationItem",
  "CubeToCombination",
  "Subdomain",
  "VariableSet",
  "SubdomainEnumeration",
  "VariableSetEnumeration",
  "CubeStructure",
  "CubeStructureItem",
  "CubeGroupEnumeration",
  "MemberHierarchyNode",
  "CubeRelationship",
  "FacetCollection",
  "FacetEnumeration",
  "VariableMappingItem",
  "MemberMappingItem",
  "VariableSetMapping",
  "MemberMapping",
  "VariableMapping",
];

const cubeTypes = [
  { label: "C", value: "C" },
  { label: "S", value: "S" },
  { label: "D", value: "D" },
];

const noBranchSelectedBranch = {
  branch: {
    tid: null,
    status: "ACTIVE",
    name: "",
  },
  project: {
    status: "OPEN",
    name: "",
  },
};

const ApproveRejectEnum = {
  NONE: 0,
  APPROVE: 1,
  REJECT: 2,
  BOTH: 3,
};

const ApprovalStatuses = [
  { label: "ALL", value: "ALL" },
  { label: "DRAFT", value: "DRAFT" },
  { label: "TO BE APPROVED", value: "TO_BE_APPROVED" },
  { label: "APPROVED", value: "APPROVED" },
  { label: "REJECTED", value: "REJECTED" },
];

const CoreApprovalStatuses = [
  { label: "ALL", value: "ALL" },
  { label: "TO BE APPROVED", value: "TO_BE_APPROVED" },
  { label: "APPROVED", value: "APPROVED" },
  { label: "REJECTED", value: "REJECTED" },
  { label: "NOT CORE", value: "NOT_CORE" },
];

const ApprovalCoreApprovalStatusesBranchTypesByFetchType = new Map([
  [
    "da_changes_in_branch",
    {
      onlyApprovalStatuses: null,
      onlyCoreApprovalStatuses: ["DRAFT", "NOT_CORE"],
      branchTypes: ["MASTER", "PRODUCTION", "BRANCH"],
    },
  ],
  [
    "mao_pending_core_approvals_in_all_projects",
    {
      onlyApprovalStatuses: [],
      onlyCoreApprovalStatuses: ["TO_BE_APPROVED"],
      branchTypes: ["MASTER", "PRODUCTION"],
      onlyBranchTypes: ["MASTER"],
    },
  ],
  [
    "mao_pending_core_approvals_in_project",
    {
      onlyApprovalStatuses: [],
      onlyCoreApprovalStatuses: ["TO_BE_APPROVED"],
      branchTypes: ["MASTER", "PRODUCTION"],
      onlyBranchTypes: ["MASTER"],
    },
  ],
  [
    "mao_promote_core_proposals_in_all_projects",
    {
      onlyApprovalStatuses: [],
      onlyCoreApprovalStatuses: ["APPROVED"],
      branchTypes: ["PRODUCTION"],
      onlyBranchTypes: ["MASTER"],
    },
  ],
  [
    "mao_promote_core_proposals_in_project",
    {
      onlyApprovalStatuses: [],
      onlyCoreApprovalStatuses: ["APPROVED"],
      branchTypes: ["PRODUCTION"],
      onlyBranchTypes: ["MASTER"],
    },
  ],
  [
    "mao_changes_in_master_branch",
    {
      onlyApprovalStatuses: ["APPROVED"],
      onlyCoreApprovalStatuses: null,
      branchTypes: ["PRODUCTION"],
    },
  ],
  [
    "mao_changes_in_release",
    {
      onlyApprovalStatuses: ["APPROVED"],
      onlyCoreApprovalStatuses: null,
      branchTypes: ["PRODUCTION"],
    },
  ],
  [
    "po_pending_approvals",
    {
      onlyApprovalStatuses: ["TO_BE_APPROVED"],
      onlyCoreApprovalStatuses: null,
      branchTypes: ["MASTER", "PRODUCTION", "BRANCH"],
    },
  ],
  [
    "po_pending_approvals_in_project",
    {
      onlyApprovalStatuses: ["TO_BE_APPROVED"],
      onlyCoreApprovalStatuses: null,
      branchTypes: ["MASTER", "PRODUCTION", "BRANCH"],
    },
  ],
  [
    "po_changes_in_master_branch",
    {
      onlyApprovalStatuses: ["APPROVED"],
      onlyCoreApprovalStatuses: null,
      branchTypes: ["PRODUCTION"],
    },
  ],
  [
    "po_approved_changes",
    {
      onlyApprovalStatuses: ["APPROVED"],
      onlyCoreApprovalStatuses: null,
      branchTypes: ["MASTER", "PRODUCTION", "BRANCH"],
    },
  ],
  [
    "po_changes_in_release",
    {
      onlyApprovalStatuses: ["APPROVED"],
      onlyCoreApprovalStatuses: null,
      branchTypes: ["PRODUCTION"],
    },
  ],
]);

const MimeType = {
  CSV: "text/csv",
  XLS: "application/vnd.ms-excel",
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ZIP: "application/zip",
};

const ExportSubFunction = {
  ENTITY_EXPORT: "ee",
  // FRAMEWORK_EXPORT: "fe",
  // MULTIPLE_FRAMEWORK_EXPORT: "mf",
  FRAMEWORKS_EXPORT: "fe",
  INDIVIDUAL_CUBE_EXPORT: "ic",
  INDIVIDUAL_CUBE_VIEW_EXPORT: "icv",
  INDIVIDUAL_VARIABLE_EXPORT: "iv",
  FRAMEWORK_MATRIX_EXPORT: "fm",
  FRAMEWORK_LOGICAL_LINEAGE: "fll",
  FRAMEWORK_MODELS_OVERVIEW: "fmo",
  FRAMEWORK_DELTA_COMPARISON: "fdc",
};

const ImportSubFunction = {
  SMCUBE: "smcube",
  INDIVIDUAL_ENTITY: "IE",
};

const ExportCategory = {
  TECHNICAL: [
    ExportSubFunction.ENTITY_EXPORT,
    ExportSubFunction.FRAMEWORKS_EXPORT,
    ExportSubFunction.FRAMEWORK_DELTA_COMPARISON,
  ],
  SIMPLIFIED: [
    ExportSubFunction.FRAMEWORK_MATRIX_EXPORT,
    ExportSubFunction.INDIVIDUAL_CUBE_EXPORT,
    ExportSubFunction.FRAMEWORK_LOGICAL_LINEAGE,
    ExportSubFunction.FRAMEWORK_MODELS_OVERVIEW,
  ],
};

// DO NOT use the constants here as keys. It will break at build time for some reasons
const ExportDescription = {
  ic: "The individual entity (Cube) export helps business users to navigate metadata of individual data models entities in a user-friendly way, allowing users to explore all the attributes, restrictions, and allowed values of the selected entities. This export is suitable for those Frameworks with a limited number of entities.",
  fm: "The framework matrix export helps users exploring entities, attributes, restrictions, and allowed values of the selected data models while allowing to easily compare the structure of its entities.",
  fll: `The transformation rules export provides information on derivation and generation transformation rules and related lineage for certain destination Frameworks to which destination entities or rendering table of the transformation rules belong.

  "Entity logical lineages" contains information on the incoming lineage for a certain destination (output) entity, its attribute and allowed values.
  
  "Rendering logical lineages" contains information on the incoming lineage for a certain destination rendering table based on its value combination (i.e., data points), attribute and allowed values.`,
  fmo: "The framework models overview export allows users to easily navigate the data models of a framework, by showing all the entities, attributes, restrictions, and allowed values of each data model. This export can be used with any type of framework, even those with large data models.",
};

const booleanFilterValueOptions = [
  { label: "true", value: true },
  { label: "false", value: false },
  { label: "null", value: "-" },
];

const BRANCH_TYPE = {
  BRANCH: "BRANCH",
  MASTER: "MASTER",
  INTERMEDIATE: "INTERMEDIATE",
  FINAL: "FINAL",
  PRODUCTION: "PRODUCTION",
};

const branchTypeFilterValueOptions = [
  { label: "BRANCH", value: "BRANCH" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "MASTER", value: "MASTER" },
  { label: "INTERMEDIATE", value: "INTERMEDIATE" },
  { label: "FINAL", value: "FINAL" },
];

const projectTypeFilterValueOptions = [
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "FRAMEWORK", value: "FRAMEWORK" },
  { label: "MAPPING", value: "MAPPING" },
];

const frameworkStatusFilterValueOptions = [
  { label: "DRAFT", value: "DRAFT" },
  { label: "PUBLISHED", value: "PUBLISHED" },
];

const approvalStatusFilterValueOptions = [
  { label: "DRAFT", value: "DRAFT" },
  { label: "TO BE APPROVED", value: "TO_BE_APPROVED" },
  { label: "APPROVED", value: "APPROVED" },
  { label: "REJECTED", value: "REJECTED" },
];

const NonFrameworkProjectType = {
  MAPPING: "MAPPING",
  RENDERING: "RENDERING",
  TRANSFORMATION: "TRANSFORMATION",
};

const notApplicableItems = [
  "Not applicable",
  "Not applicable / Not subject to impairment",
  "Not applicable/Not subject to imparment",
  "Not applicable (Mode of participation in FMI)",
  "not applicable",
  "Not applicable (no relationship)",
  "Not applicable/ All counterparties",
  "Not applicable/ All exposure classes",
  "Not applicable/ All situations related to external ratings",
  "Not applicable/ All credit protections",
  "Not applicable/ All applicable percentages",
  "Not applicable/All purposes",
  "Not applicable/ Total exposures",
  "Not applicable/ All approaches",
  "Total/Not applicable",
  "Not applicable/All activities",
  "Not applicable/ All types of underlying exposures",
  "Not applicable/ All base items",
  "Not applicable/All roles in the securitisation process",
  "Not applicable/All securitisation structures",
  "Not applicable/All portfolios",
  "Not applicable/All positions",
  "Not applicable/All risks",
  "Not applicable/ All own funds",
  "Not applicable/ All currencies",
  "Not applicable/All geographical areas",
  "Not applicable/ All credit quality steps",
  "Not applicable/All risk transfer treatments",
  "Not applicable/ All time intervals",
  "Not applicable/All relationships",
  "N - Not applicable",
  "Not applicable / all hedges",
  "Not applicable (exposure class)",
  "Not applicable (default status)",
  "Not applicable (approach)",
  "Not applicable (FMI system type)",
  "Not applicable (Contractual recognition of bail-in powers)",
  "Not applicable/ All CTPs",
  "Not applicable / Expressed in (converted to) reporting currency",
  "Not applicable/ All collateral pledges/ All guarantees",
  "Not applicable/ All instruments",
  "Not applicable/ All events",
  "Not applicable/ All amounts",
  "Not applicable/All liquidity conditions",
  "Not applicable/ All types of markets",
  "Not applicable/ Not specified",
  "Not applicable/ All NACE Codes",
];

const cubeLinkVariables = {
  tooltip:
    "Further hierarchies (breakdowns) are available for this Member. For example, they can depend on a specific Framework regulation. Click on one of the options on the left to display them.",
};

const referenceFramework = {
  tooltip:
    "Harmonised and standardised version (i.e. Semantically-integrated) of the Framework. i.e. using the common dictionary of the SDD. These frameworks are easy to be matched across each other when relevant",
};

const nonReferenceFramework = {
  tooltip:
    "Original version of the Framework, using a different dictionary (i.e. different semantic/codification system)",
};

const searchTooltip = {
  tooltip:
    "It allows to search for: attributes (i.e. Variables, e.g. Accounting Classification) and related allowed values; tables, templates (i.e. Cubes, e.g. AnaCredit Instrument table or a FinRep template), values of allowed values (i.e. Members, e.g. definitions of specific default statuses) and more. You can search by Code, Name or Description of those information. Just copy the code of a column of a DISC table and insert in the search to find out its meaning!",
};

const CUBE_QUERY_WIZARD_SQL_QUERY_PART = {
  SELECT_FIELDS: "SELECT_FIELDS",
  FILTER_FIELDS: "FILTER_FIELDS",
};

const FRAMEWORK_UPDATE_DESCRIPTIONS = {
  LAST_DATA_MODEL_UPDATE:
    " Latest date of changes affecting only the data model: the addition/update of attributes code or changes in the logical data types. In comparison to the “Latest content or validation update” date, this date does not change if “only” addition/changes of allowed values or validations were made.",
  LAST_CONTENT_UPDATE:
    "Latest date of changes affecting the data model or the business content. This includes changes of the data model as defined in the “latest data model update” date or/and addition/changes of allowed values or validations. It does not include descriptive changes (e.g. changes of attributes or allowed values name or descriptions).",
};

const dateFormatForFrameworkChanges = "YYYY-MM-DD HH:mm";

const dateFormatForActionsAndEvents = "YYYY-MM-DD HH:mm:ss";

const dateFormatYYYYMMDD = "yyyy-MM-dd";

const FILE_FORMAT = {
  XLSX: {
    name: "xlsx",
    getMimetype: () => MimeType.XLSX,
  },
};

const VALIDATION_TYPE = {
  MASTER_BRANCH_CHANGES: {
    issuer: "F_MASTER_BRANCH_CHANGES",
  },
  DA_WORKING_BRANCH_CHANGES: {
    issuer: "F_DA_WORKING_BRANCH_CHANGES",
  },
  RELEASE: {
    issuer: "F_RELEASE",
  },
  CONTENT_MANAGEMENT_TABLE: {
    issuer: "OTHER",
  },
  APPROVAL_CHANGES: {
    issuer: "OTHER",
  },
  GENERAL: {
    issuer: "OTHER",
  },
};

const NAVIGATION_TABS_FOR_PAGES = {
  Cube: [
    { TemplateRepresentation: "Template" },
    {
      CubeRepresentation: "Cube",
    },
    { CubeComparison: "Compare" },
    { LinkedCubes: "Linked Cubes" },
    { SimilarObjects: "Search similar" },
    { CubeVariablesMapping: "Mapping" },
    { Related: "Related" },
  ],
};

const DATAMODELS_TYPES = {
  TEMPLATE_HIERARCHY: "TH",
};

module.exports = Object.freeze({
  cm_CONSTANT_entity_tables,
  cubeTypes,
  noBranchSelectedBranch,
  ApproveRejectEnum,
  ApprovalStatuses,
  CoreApprovalStatuses,
  ApprovalCoreApprovalStatusesBranchTypesByFetchType,
  MimeType,
  ExportSubFunction,
  ImportSubFunction,
  ExportCategory,
  ExportDescription,
  booleanFilterValueOptions,
  BRANCH_TYPE,
  branchTypeFilterValueOptions,
  projectTypeFilterValueOptions,
  frameworkStatusFilterValueOptions,
  approvalStatusFilterValueOptions,
  NonFrameworkProjectType,
  EntityTypesThatCanBeOrphan,
  notApplicableItems,
  cubeLinkVariables,
  referenceFramework,
  nonReferenceFramework,
  searchTooltip,
  CUBE_QUERY_WIZARD_SQL_QUERY_PART,
  FRAMEWORK_UPDATE_DESCRIPTIONS,
  dateFormatForFrameworkChanges,
  dateFormatForActionsAndEvents,
  dateFormatYYYYMMDD,
  labelForClassifications,
  labelForLegalReference,
  FILE_FORMAT,
  NAVIGATION_TABS_FOR_PAGES,
  VALIDATION_TYPE,
  DATAMODELS_TYPES,
});
